import React                  from 'react';
import {
  Paper,
  Typography,
  Divider,
}                             from '@material-ui/core';
import { useTranslation }     from 'react-i18next';
import useStyles              from './styles';
import GridItem               from '../../GridItem';
import GridContainer          from '../../GridContainer';

function CardPreview(props) {
  const { background, cardType } = props;
  const { t } = useTranslation();
  const classes = useStyles();
  const isHead = cardType === 'img_head';

  function CardType(props) {
    const { cardType, image, title, description, text_color, title_color, url } = props;
    if ( cardType === 'img_left' ) {
      return (
        <GridContainer>
          <GridItem
            xs={3} md={3}
            className={classes.paper}>
            <div className={classes.image}>
              <img className={classes.img} src={image}/>
            </div>
          </GridItem>
          <GridItem
            xs={9} md={9}
            className={classes.textGrid}>
            <Typography className={classes.titleLeft} style={{ color: title_color }}>{title}</Typography>
            <div className={classes.descriptionLeft} style={{ color: text_color }}>{description}</div>
          </GridItem>
        </GridContainer>
        );
    }else if ( cardType === 'img_right' ) {
      return (
        <GridContainer>
          <GridItem
            xs={8} md={9}
            className={classes.textGrid}>
            <Typography className={classes.titleRight} style={{ color: title_color }}>{title}</Typography>
            <div className={classes.descriptionRight} style={{ color: text_color }}>{description}</div>
          </GridItem>
          <GridItem
            xs={6} md={3}
            className={classes.paper}>
            <div className={classes.image}>
              <img className={classes.img} src={image}/>
            </div>
          </GridItem>
        </GridContainer>
      );
    }else if ( cardType === 'img_bg' ) {
      return (
        <GridContainer>
          <GridItem
            xs={8} md={12}
            className={classes.textGrid}>
            <Typography className={classes.titleBackground} style={{ color: title_color }}>{title}</Typography>
            <div className={classes.descriptionBackground} style={{ color: text_color }}>{description}</div>
          </GridItem>
        </GridContainer>
      );
    }else if ( cardType === 'img_head' ) {
      return (
        <GridContainer>
          <GridItem
            xs={12} md={12}
            className={classes.paper}>
            <div className={classes.image}>
              <img className={classes.img_head} src={image}/>
            </div>
          </GridItem>
          <GridItem
            xs={12} md={12}
            className={classes.textGrid}>
            <Typography className={classes.titleHeader} style={{ color: title_color }}>{title}</Typography>
            <div className={classes.descriptionHeader} style={{ color: text_color }}>{description}</div>
            {url &&<>
              <Divider variant='fullWidth'/>
              <Typography>{t('seeMore')}</Typography>
            </>}
          </GridItem>
        </GridContainer>
      );
    }
  }

  return (
    <div
      className={classes.root}
      style={{paddingTop: 60, paddingBottom: 60, paddingLeft: 75, paddingRight: 75, textAlign: isHead ? 'center' : 'inherit'}}
    >
      {!isHead && <Paper
        elevation={5}
        className={classes.container}
        style={{backgroundColor: background, padding: 30, flex: 1}}
      >
        <CardType
          {...props}
        />
      </Paper>}
      {isHead && <Paper
        elevation={5}
        className={classes.head}
        style={{
          backgroundColor: background,
          padding: 30,
          flex:1,
          width:360,
          height: 'fit_content',
          flexDirection: 'column',
          textAlign: 'left',
        }}
      >
        <CardType
          {...props}
        />
      </Paper>}
    </div>
  );
}

export default CardPreview;
